import Router from 'vue-router'
import Config from 'theme/config'

export default () => {
  const routes = [
    {
      path: `/:lang(${Config.Theme.storeviewRegex})`,
      component: () => import('theme/pages/Lang/Lang.vue'),
      meta: {
        root: true
      },
      children: [
        {
          path: 'redirect',
          name: 'redirect',
          component: () => import('theme/pages/Redirect.vue'),
          meta: {
            tplName: 'redirect',
            authAdmin: { name: 'oldapp' },
            layout: 'no-sidebar'
          }
        },
        {
          path: '',
          name: 'home',
          component: () => import('theme/pages/Home.vue'),
          meta: {
            tplName: 'homepage',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('./pages/Login.vue'),
          meta: {
            tplName: 'myaccount_other',
            layout: 'no-sidebar'
          }
        },
        {
          path: 'my-orders',
          name: 'myOrders',
          component: () => import('./pages/MyAccount/MyOrders.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'my-orders/:id',
          name: 'myOrder',
          component: () => import('./pages/MyAccount/MySingleOrder.vue'),
          meta: {
            tplName: 'myaccount_other',
            title: 'my-order',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'boutique',
          name: 'ManageBoutique',
          redirect: () => {
            if (process.client) {
              if (global.$store.state.userAdmin.storeCode) {
                return { path: `boutique/${global.$store.state.userAdmin.storeCode}` }
              } else {
                return { name: 'home' }
              }
            }
          }
        },
        {
          path: 'boutique/:store_code',
          name: 'Boutique',
          component: () => import('./pages/StoreDetails.vue'),
          meta: {
            tplName: 'other_store',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'my-returns',
          name: 'myReturns',
          component: () => import('./pages/MyAccount/MyReturns.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'my-returns/edit/:id',
          name: 'editReturns',
          component: () => import('./pages/MyAccount/MyReturnsEdit.vue'),
          meta: {
            tplName: 'myaccount_other',
            title: 'detailRma',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'my-returns/new',
          name: 'newReturns',
          component: () => import('./pages/MyAccount/MyReturnsNew.vue'),
          meta: {
            tplName: 'myaccount_other',
            title: 'newRma',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'return-and-refunds/init',
          name: 'createGuestReturn',
          component: () => import('./pages/CreateGuestReturn.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'return-and-refunds/success/:id/:email',
          name: 'ReturnSuccess',
          component: () => import('./pages/MyAccount/Returns/ReturnSuccess.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'return-and-refunds/cancelled/:id/:email',
          name: 'ReturnCancelled',
          component: () => import('./pages/MyAccount/Returns/ReturnCancelled.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' }
          }
        },
        {
          path: 'return-and-refunds/new/:id/:email',
          name: 'newGuestReturn',
          component: () => import('./pages/MyAccount/MyReturnsNew.vue'),
          meta: {
            tplName: 'myaccount_other',
            authAdmin: { name: 'login' },
            title: 'newRma'
          }
        },
        {
          path: 'search.html',
          name: 'search',
          component: () => import('./pages/Listing.vue'),
          meta: {
            search: true,
            tplName: 'internal_search'
          }
        },
        {
          path: 'onestepcheckout',
          name: 'onepagecheckout',
          component: () => import('theme/pages/CheckoutOnePage.vue'),
          meta: {
            tplName: 'funnel_step2'
          }
        },
        {
          path: 'thankyou',
          name: 'thankyou',
          component: () => import('theme/components/Checkout/Thankyou.vue'),
          meta: {
            tplName: 'funnel_confirmation'
          }
        },
        {
          path: 'page-not-found',
          name: 'page-not-found',
          meta: {
            tplName: 'other_errors'
          },
          redirect: { name: 'home' }
        }
      ]
    },
    {
      path: '*',
      // redirect: `${process.env.VUE_APP_BASE_PATH}/_`
      redirect: { name: `home`, params: { lang: process.env.VUE_APP_STOREVIEWCODE } }
    }
  ]

  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: (to, from, savedPosition) => {
      if (to.hash) {
        return {
          selector: to.hash
        }
      }

      let position = savedPosition || { x: 0, y: 0 }
      return position
    }
  })

  return router
}
